import {Store, StoreConfig} from "@datorama/akita";
import {initialState, UIState} from "./models";

@StoreConfig({name: 'ui'})
export class UIStore extends Store<UIState> {
    constructor() {
        super(initialState());
    }
}